import React from "react";
import JourneyPlaceCard from "./JourneyPlaceCard";

// The journey's places, as cards in route order (Add Journey and Edit Journey).
// Everything a card needs comes from the page: `cardProps(place, index)` gives
// that card's own state and actions, so one place's card never shares state
// with another's. With no places yet it shows nothing: the Add Journey Place
// card below it is the first thing on the page.
export default function JourneyPlaceList({ places, cardProps }) {
  if (places.length === 0) return null;
  return (
    <section className="tsp-jb-places" aria-label="Journey places">
      <div className="tsp-route-list-head">
        <h2 className="tsp-subheading">Journey Places</h2>
        <span className="tsp-status-pill tsp-status-pill-muted">
          {places.length} {places.length === 1 ? "place" : "places"}
        </span>
      </div>
      <ol className="tsp-pc-list">
        {places.map((place, index) => (
          <JourneyPlaceCard key={place.key} place={place} order={index + 1} total={places.length} {...cardProps(place, index)} />
        ))}
      </ol>
    </section>
  );
}
